export default function Advantages() {
  const advantages = [
    {
      icon: 'ri-flashlight-line',
      title: 'Rapidité',
      description: 'Livraisons express et respect strict des délais pour garantir la fraîcheur de vos fleurs'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Fiabilité',
      description: 'Service professionnel et sécurisé avec suivi en temps réel de vos commandes'
    },
    {
      icon: 'ri-heart-3-line',
      title: 'Soin',
      description: 'Manipulation délicate et transport adapté pour préserver la qualité de vos produits'
    },
    {
      icon: 'ri-map-pin-2-line',
      title: 'Proximité',
      description: 'Basés à Rungis, au cœur du marché international des fleurs'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Expertise',
      description: 'Équipe expérimentée et spécialisée dans la logistique florale'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Tarifs Compétitifs',
      description: 'Solutions adaptées à tous les budgets avec un excellent rapport qualité-prix'
    }
  ];

  return (
    <section id="advantages" className="py-20 bg-gradient-to-br from-black to-emerald-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Pourquoi Nous Choisir ?
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Des avantages concrets pour votre activité florale
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-sm p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow border border-white/20"
            >
              <div className="w-14 h-14 bg-emerald-600 rounded-full flex items-center justify-center mb-5">
                <i className={`${advantage.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                {advantage.title}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {advantage.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}